import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM is ready, especially on mobile
    const scrollToTop = () => {
      // Multiple methods to ensure it works across all browsers and devices
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'instant' for immediate scroll (works better on mobile)
      });
      
      // Fallback for older browsers
      if (window.scrollY !== 0) {
        window.scrollTo(0, 0);
      }
      
      // Direct property setting (works on mobile Safari)
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // For mobile browsers that use different scroll containers
      const rootElement = document.documentElement || document.body;
      if (rootElement.scrollTop !== 0) {
        rootElement.scrollTop = 0;
      }
    };

    // Immediate scroll
    scrollToTop();

    // Also try after a small delay to catch any late-rendering content
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 0);

    // Use requestAnimationFrame for better mobile support
    const rafId = requestAnimationFrame(() => {
      scrollToTop();
    });

    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(rafId);
    };
  }, [pathname, search]); // Also trigger on search params change (query strings)

  return null;
};

export default ScrollToTop;

